import { render, staticRenderFns } from "./lightModel.vue?vue&type=template&id=61a9bda5&scoped=true&"
import script from "./lightModel.vue?vue&type=script&lang=js&"
export * from "./lightModel.vue?vue&type=script&lang=js&"
import style0 from "./lightModel.vue?vue&type=style&index=0&id=61a9bda5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a9bda5",
  null
  
)

export default component.exports